import { render, staticRenderFns } from "./ReferenceListView.vue?vue&type=template&id=73a91876&scoped=true"
import script from "./ReferenceListView.vue?vue&type=script&lang=js"
export * from "./ReferenceListView.vue?vue&type=script&lang=js"
import style0 from "./ReferenceListView.vue?vue&type=style&index=0&id=73a91876&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a91876",
  null
  
)

export default component.exports